import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions } from 'react-redux-form';
import OtpTransferCodeBox from 'componentsV2/OTPTransferCodeBox/OTPTransferCodeBox';
import OtpTransferSteps from 'componentsV2/OTPTransfer/OTPTransferSteps/OTPTransferSteps';
import OtpTransferStepsTitle from 'componentsV2/OTPTransfer/OTPTransferStepsTitle';
import OtpTransferHelpModal from 'componentsV2/OTPTransfer/OTPTransferHelpModal';
import FullForm from '../Layouts/FullForm';
import { hidePreLoader, showPreLoader } from 'actions/preLoaderActions';
import { getOtpSteps } from './utils';
import { toCamelCase } from 'utilities/stringHelper';
import { checkConditionAndExecuteCallback } from 'utilities/toggling';
import Storage from 'utilities/storage';
import 'componentsV2/OTPTransfer/OTPTransfer.scss';
import { PENDING_OTP, TRANSFER_OTP } from '../commons/constants/steps';
import { IBAN_TRANSFER_OTP_SEND_OTP } from 'constants/identityMethod'; //not sure
import { formatText, FormattedText } from 'core/i18n';
import { ibanTransferOTPCall } from 'actions/ibanActions';
import { enableFinishedAndNextStep, finalizeStep, changeCurrentStep } from 'actions/stepsActions';
import { loanStatus } from '../../actions/aresActions';
import modalCancelActions from 'actions/modalCancelActions';
import { goToErrorsView } from 'actions/errorViewNavigation';

const { change } = actions;

class TransferOtp extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            continueButtonEnabled: false,
            date: 'XX/XX/XX',
            iban: '',
            showHelpModal: false,
            checkBoxAlternativeOption: false,
            showAlternativeOptionModal: false,
            entityName: '',
            immediate: true,
            retryOtp: false,
            retryTransfer: false,
        };
    }

    UNSAFE_componentWillMount = () => {
        const {
            userProfile: { status },
            showPreLoader,
            hidePreLoader,
            ibanTransferOTPCall,
        } = this.props;

        setTimeout(() => {
            showPreLoader();
        });
        checkConditionAndExecuteCallback(status === TRANSFER_OTP, async () => {
            const { change } = this.props;
            try {
                const sendOtpCall = await ibanTransferOTPCall(
                    Storage.cookies.get('accessToken'),
                    'POST',
                    IBAN_TRANSFER_OTP_SEND_OTP
                );
                if (sendOtpCall.status === 'OK') {
                    await this.setOtpTransferData();
                    this.handleContinueButtonEnabled(true);
                }
            } catch (e) {
                goToErrorsView({ errorContent: 'messagesScreen-transferErrorContent' });
            } finally {
                await hidePreLoader();
            }
        });

        checkConditionAndExecuteCallback(status === PENDING_OTP, async () => {
            try {
                await this.setOtpTransferData();
            } catch (e) {
                goToErrorsView({ errorContent: 'messagesScreen-transferErrorContent' });
            } finally {
                await hidePreLoader();
            }
        });
    };

    setOtpTransferData = async () => {
        const { ibanTransferOTPCall } = this.props;
        const transferOtpResponse = await ibanTransferOTPCall(Storage.cookies.get('accessToken'), 'GET');
        this.setState({ ...transferOtpResponse });
    };

    handleContinueButtonEnabled = value => this.setState({ continueButtonEnabled: value });

    handleSetOtpTransferData = async () => {
        const { ibanTransferOTPCall } = this.props;
        const transferOtpResponse = await ibanTransferOTPCall(Storage.cookies.get('accessToken'), 'GET');
        this.setState({ ...transferOtpResponse });
    };

    displayHelpModal = (event, display) => {
        event.preventDefault();
        this.setState({ showHelpModal: display });
    };

    getNextStep = () => {
        const { showPreLoader, getLoanStatus } = this.props;
        showPreLoader();
        getLoanStatus();
    };

    cancelStep = () => {
        const { modalCancelActions } = this.props;
        modalCancelActions.showModalCancel();
    };

    render() {
        const { date, showHelpModal, iban, entityName, retryOtp, retryTransfer, continueButtonEnabled } = this.state;
        const {
            userProfile: { name },
        } = this.props;

        return (
            <React.Fragment>
                <FullForm
                    className="otp-transfer-container"
                    title={formatText('StepsTitles-transferOtpValidation')}
                    subtitle={formatText('StepsTitles-transferOtpValidationDescription', [
                        toCamelCase(name),
                        iban,
                        entityName,
                    ])}
                    formModel="userProfile"
                    icon="identificacion"
                    hideRoadMapNavigation={false}
                    continueAction={this.getNextStep}
                    cancelAction={this.cancelStep}
                    continueButtonEnabled={continueButtonEnabled}
                >
                    <div className="opt-transfer-container-content">
                        <OtpTransferStepsTitle name={name} />
                        <OtpTransferSteps
                            otpSteps={getOtpSteps(FormattedText, [date.substring(0, 11), date.substring(11)])}
                        />
                        <OtpTransferCodeBox
                            onHandleSetOtpTransferData={this.handleSetOtpTransferData}
                            showHelpModal={event => this.displayHelpModal(event, true)}
                            retryOtp={retryOtp}
                            retryTransfer={retryTransfer}
                            onHandleDisableNextButton={value => this.handleContinueButtonEnabled(!value)}
                            displayCodeNotFound={true}
                        />
                    </div>
                </FullForm>
                <OtpTransferHelpModal
                    showModal={showHelpModal}
                    hideModal={event => this.displayHelpModal(event, false)}
                />
            </React.Fragment>
        );
    }
}

export default connect(
    state => ({
        errorState: state.error,
        userProfile: state.userProfile,
        immStepsState: state.steps,
        products: state.products,
    }),
    dispatch => ({
        hidePreLoader: bindActionCreators(hidePreLoader, dispatch),
        showPreLoader: bindActionCreators(showPreLoader, dispatch),
        ibanTransferOTPCall: bindActionCreators(ibanTransferOTPCall, dispatch),
        enableFinishedAndNextStep: bindActionCreators(enableFinishedAndNextStep, dispatch), //not sure
        finalizeStep: bindActionCreators(finalizeStep, dispatch),
        getLoanStatus: bindActionCreators(loanStatus, dispatch),
        changeCurrentStep: bindActionCreators(changeCurrentStep, dispatch),
        change: bindActionCreators(change, dispatch),
        modalCancelActions: bindActionCreators(modalCancelActions, dispatch),
    })
)(TransferOtp);
